export default __webpack_public_path__ + "static/collection-5-9e7cf1770a4a701d8b608c5b2a943199.webp";